import { Location } from '@angular/common';
import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { filter, firstValueFrom, Subscription } from 'rxjs';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { ClientStateEnums } from 'src/app/enum/client-state-enums';
import { ConstructionSiteStateEnums } from 'src/app/enum/construction-site-enums';
import { SuspensionStateEnums } from 'src/app/enum/suspension-state-enum';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';
import { BranchModel } from 'src/app/models/management/branch.model';
import { SuspensionPrintModel } from 'src/app/models/rental/suspension-print-model';
import { SuspensionModel } from 'src/app/models/rental/suspension.model';
import { WindowService } from 'src/app/services/authentication/window.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { InvoiceService } from 'src/app/services/invoicing/invoice.service';
import { MaintenanceOrderService } from 'src/app/services/maintenance/maintenance-order.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { SuspensionService } from 'src/app/services/rental/suspension.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-register-suspension',
  templateUrl: './register-suspension.component.html',
  styleUrls: ['./register-suspension.component.scss'],
  standalone: false
})
export class RegisterSuspensionComponent implements OnInit {

  branchId: number = 0;
  clientStateId: number = ClientStateEnums.activo;
  clientStateOpen: number = ClientStateEnums.activo;
  companyId: number = 0;
  consecutive: number = 0;
  constructionSiteStateId: number = ConstructionSiteStateEnums.activa;
  constructionSiteStateOpen: number = ConstructionSiteStateEnums.activa;
  disabledActions: boolean = true;
  disabledDetail: boolean = true;
  disabledForm: boolean = true;
  filteredCostCenters: any[] = [];
  formSuspension: FormGroup = new FormGroup({});
  iconStateSuspension: string = '';
  isOpened: string | undefined = undefined;
  invoicingCutoffCode: number | string = '';
  dataPeriod: number | string = '';
  listBranches: CustomListDropdown[] = [];
  listCostCenters: any[] = [];
  listClients: CustomListDropdown[] = [];
  maintenanceOrderConsecutive: number | string = '';
  mainBranchByUser: BranchModel = new BranchModel();
  messageStateSuspension: string = '';
  nameWindow: string = 'Captura Suspensiones';
  permissionPrint: boolean = false;
  permissionUpdatable: boolean = false;
  projectName = ProjectName.projectName;
  quantityDetails: number = 0;
  reloadPrint: boolean = false;
  severityState: string = "danger";
  stateClientOpen: number = ClientStateEnums.activo;
  statePeriod: boolean = false;
  subscription: Subscription;
  suspensionContract: SuspensionModel = new SuspensionModel();
  suspensionId: number = 0;
  suspensionPrintModel: SuspensionPrintModel = new SuspensionPrintModel();
  suspensionStateString: string = '';
  titleStateSuspension: string = '';
  url: string = 'suspension';

  constructor(private activatedRoute: ActivatedRoute,
    private branchService: BranchService,
    private dateConverterService: DateConverterService,
    private formBuilder: FormBuilder,
    private formControlStateService: FormControlStateService,
    private headerService: HeaderService,
    private invoiceService: InvoiceService,
    private maintenanceOrderService: MaintenanceOrderService,
    private location: Location,
    private router: Router,
    private suspensionService: SuspensionService,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService,
    private cdr: ChangeDetectorRef) {
    this.validateForm(this.suspensionContract);
  }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    await this.getPermission();
    this.activatedRoute.params.subscribe(params => {
      this.suspensionId = Object.keys(params).length > 0 ? params?.id : null;
    });
    this.handleInitialState();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  async annulSuspension() {
    if (this.isBlockedByMaintenanceOrder()) return;
    if (this.suspensionContract.suspensionId != 0 && this.suspensionContract.suspensionId != null) {
      if (this.quantityDetails > 0) {
        this.toastHandlerService.showToast('warning', 'No es posible anular la suspensión, mientras tenga detalle.', 'Atención');
        return;
      }
      if (this.suspensionContract.suspensionStateId === SuspensionStateEnums.closed) {
        this.toastHandlerService.showToast('warning', 'No es posible anular, la suspensión se encuentra cerrada.', 'Atención');
        return;
      }
      if (this.permissionUpdatable) {
        Swal.fire({
          title: 'Atención',
          text: "¿Realmente desea anular la suspensión?",
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si',
          cancelButtonText: 'No'
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {
              const response = await firstValueFrom(this.suspensionService.annulSuspension(this.suspensionContract.suspensionId));
              this.suspensionContract = response;
              this.validateForm(this.suspensionContract);
              this.toastHandlerService.showToast('success', 'La suspensión se anuló exitosamente.', '');
            } catch (error) {
              console.error('Error while annulling the suspension.', error);
            }
          }
        });
      } else {
        this.toastHandlerService.showToast('error', 'El usuario no tiene permisos para anular suspensiones. Comuníquese con el administrador del sistema.', 'Error');
      }
    } else {
      this.toastHandlerService.showToast('warning', 'Debe crear un suspensión.', 'Atención');
    }
  }

  async blockSuspension(value: boolean) {
    if (this.suspensionContract.suspensionId != 0 && this.suspensionContract.suspensionId != null) {
      const suspensionId = this.suspensionContract.suspensionId;
      try {
        this.suspensionContract = await firstValueFrom(this.suspensionService.blockSuspension(suspensionId));
        this.validateForm(this.suspensionContract);
      } catch (error) {
        this.formSuspension.controls["swBlock"].setValue(!value);
        console.error('Error to block suspension.', error);
      }
    } else {
      this.formSuspension.controls["swBlock"].setValue(!value);
      this.toastHandlerService.showToast('warning', 'Debe crear una suspensión.', 'Atención');
      return;
    }
  }

  async changeBranch(branchId: number | null) {
    if (branchId != null && branchId != 0) {
      this.suspensionId = 0;
      this.branchId = branchId;
      await this.getAllLists(true);
      this.resetVariables();
      this.suspensionContract = new SuspensionModel();
      this.suspensionContract.branchId = branchId;
      this.validateForm(this.suspensionContract);
      this.location.replaceState(`/${this.url}/register`);
    }
  }

  async changeConsecutive() {
    const branchId = this.formSuspension.get("branchId")?.value;
    let consecutive = this.formSuspension.get("consecutive")?.value;
    if (this.branchId == null || this.branchId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.', 'Atención');
      return;
    } else if (consecutive <= 0 || consecutive == '' || consecutive == null) {
      consecutive = 0;
    }
    if (consecutive == 0) {
      this.resetVariables();
      this.suspensionContract = new SuspensionModel();
      this.suspensionContract.branchId = branchId;
      this.validateForm(this.suspensionContract);
      this.location.replaceState(`/${this.url}/register`);
    } else {
      try {
        const response = await firstValueFrom(this.suspensionService.getSuspensionByKeysAsync(branchId, consecutive));
        this.suspensionContract = response;
        this.suspensionId = response.suspensionId;
        this.validateForm(this.suspensionContract);
        this.location.replaceState(`/${this.url}/register/${this.suspensionId}`);
      } catch (error) {
        this.formSuspension.controls["consecutive"].setValue(this.suspensionContract.consecutive);
        console.error('Error while getting the suspension by keys.', error);
      }
    }
  }

  async changeStateSuspension() {
    if (this.isBlockedByMaintenanceOrder()) return;
    if (this.suspensionContract.consecutive == 0) {
      this.toastHandlerService.showToast('warning', 'La suspensión no está guardada.', 'Atención');
      return;
    }
    if (this.permissionUpdatable) {
      try {
        const response = await firstValueFrom(this.suspensionService.setSuspensionState(this.suspensionContract.suspensionId));
        this.suspensionContract = response;
        this.validateForm(this.suspensionContract);
        this.toastHandlerService.showToast('success', 'El estado de la suspensión se modificó exitosamente.', '');
      } catch (error) {
        console.error('Error while updating the suspension status.', error);
      }
    } else {
      this.toastHandlerService.showToast('error', 'El usuario no tiene permisos para cambiar estados de suspensión. Comuníquese con el administrador del sistema.');
    }
  }

  createNewRegister() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', 'El usuario no tiene permisos para crear suspensiones. Comuníquese con el administrador del sistema', 'Atención');
      return;
    }
    this.resetVariables();
    this.suspensionContract = new SuspensionModel();
    this.suspensionContract.consecutive = 0;
    this.suspensionContract.branchId = this.branchId;
    this.validateForm(this.suspensionContract);
    this.location.replaceState(`/${this.url}/register`);
  }

  async deleteSuspension() {
    if (this.isBlockedByMaintenanceOrder()) return;
    if (this.suspensionContract.suspensionId != 0 && this.suspensionContract.suspensionId != null) {
      if (this.quantityDetails > 0) {
        this.toastHandlerService.showToast('warning', 'No es posible eliminar una suspensión, mientras tenga detalle.', 'Atención');
        return;
      }
      if (this.permissionUpdatable) {
        const result = await Swal.fire({
          title: 'Atención',
          text: "¿Realmente desea eliminar la suspensión?",
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si',
          cancelButtonText: 'No'
        });
        if (result.isConfirmed) {
          try {
            await firstValueFrom(this.suspensionService.deleteSuspension(this.suspensionContract.suspensionId));
            this.toastHandlerService.showToast('success', 'La suspensión fue eliminada exitosamente.', '');
            this.createNewRegister();
          } catch (error) {
            console.error('Error while deleting the suspension.', error);
          }
        }
      } else {
        this.toastHandlerService.showToast('error', 'El usuario no tiene permisos para eliminar suspensiones. Comuníquese con el administrador del sistema.', 'Error');
      }
    } else {
      this.toastHandlerService.showToast('warning', 'Debe crear un suspensión.', 'Atención');
    }
  }

  finishLoading(finishPrint: boolean) {
    if (finishPrint) window.print();
  }

  async getAllLists(reload: boolean): Promise<boolean> {
    try {
      if (reload) {
        const costCenters = await firstValueFrom(this.suspensionService.getAllCostCentersForSelectAsync(this.branchId));
        this.listCostCenters = costCenters;
      } else {
        const [branches, costCenters, clients] = await Promise.all([
          firstValueFrom(this.branchService.getAllBranchesForSelectAsync()),
          firstValueFrom(this.suspensionService.getAllCostCentersForSelectAsync(this.branchId)),
          firstValueFrom(this.suspensionService.getAllClientsForSelectAsync()),
        ]);
        this.listBranches = branches;
        this.listCostCenters = costCenters;
        this.filteredCostCenters = this.listCostCenters;
        this.listClients = clients;
      }
      return true;
    } catch (error) {
      console.error('Error getting the lists.', error);
      return false;
    }
  }

  async getButtonClick(buttonClick: any) {
    this.branchId = this.formSuspension.get("branchId")?.value;
    this.consecutive = this.formSuspension.get("consecutive")?.value;
    if (this.branchId == null || this.branchId == 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.', 'Atención');
      return;
    }
    this.handleSuspensionNavigation(buttonClick, this.branchId, this.consecutive)
  }

  async getClient(clientId: number | null) {
    try {
      const hasDetails = this.quantityDetails > 0;
      const previousClientId = this.suspensionContract.costCenter?.clientId;
      if (this.hasMaintenanceOrder) {
        this.rejectMaintenanceOrderChange('clientId', previousClientId ?? null);
        return;
      }
      if (hasDetails) {
        if (!clientId) {
          this.toastHandlerService.showToast('error', 'No puede limpiar el cliente si la suspensión tiene detalle.', 'Error');
        } else if (clientId !== previousClientId) {
          this.toastHandlerService.showToast('error', 'No puede cambiar el cliente si la suspensión tiene detalle.', 'Error');
        }
        setTimeout(() => this.formSuspension.controls["clientId"].patchValue(previousClientId));
        return;
      }
      if (!clientId) {
        this.filteredCostCenters = this.listCostCenters;
        this.formSuspension.controls["costCenterId"].patchValue(null);
        return;
      }
      if (clientId !== previousClientId) {
        this.formSuspension.controls["costCenterId"].patchValue(null);
      }
      this.filteredCostCenters = this.listCostCenters.filter(cc => cc.clientId === clientId);
      const client = await firstValueFrom(this.invoiceService.getClientByIdForRegisterInvoiceAsync(clientId));
      this.clientStateId = client.clientStateId;
      if (client.clientStateId == ClientStateEnums.inactivo) {
        this.toastHandlerService.showToast('warning', 'El cliente seleccionado se encuentra inactivo.', 'Atención');
        this.formSuspension.controls["clientId"].patchValue(null);
        this.formSuspension.controls["costCenterId"].patchValue(null);
        this.filteredCostCenters = this.listCostCenters;
        return;
      }
    } catch (error) {
      console.error('Error al obtener el cliente con id.', error);
    }
  }

  async getCostCenter(costCenterId: number | null, isInitialLoad: boolean) {
    try {
      const hasDetails = this.quantityDetails > 0;
      const previousCostCenterId = this.suspensionContract.costCenterId;
      if (!isInitialLoad && this.hasMaintenanceOrder) {
        this.rejectMaintenanceOrderChange('costCenterId', previousCostCenterId);
        return;
      }
      if (!isInitialLoad && hasDetails) {
        if (!costCenterId) {
          this.toastHandlerService.showToast('error', 'No puede limpiar el centro de costos si la suspensión tiene detalle.', 'Error');
        } else if (costCenterId !== previousCostCenterId) {
          this.toastHandlerService.showToast('error', 'No puede cambiar el centro de costos si la suspensión tiene detalle.', 'Error');
        }
        setTimeout(() => this.formSuspension.controls["costCenterId"].patchValue(previousCostCenterId));
        return;
      }
      if (!costCenterId) {
        const clientId = this.formSuspension.get("clientId")?.value;
        this.formSuspension.patchValue({ costCenterId: null, sellerId: null });
        this.filteredCostCenters = this.listCostCenters.filter(cc => !clientId || cc.clientId === clientId);
        return;
      }
      const response = await firstValueFrom(this.suspensionService.getCostCenterByIdForRegisterSuspension(costCenterId));
      if (!isInitialLoad && (response.constructionSiteStateId == ConstructionSiteStateEnums.inactiva)) {
        this.toastHandlerService.showToast('warning', 'El centro de costos seleccionado se encuentra inactivo.', 'Atención');
        this.formSuspension.patchValue({ clientId: null, costCenterId: null, sellerId: null });
        this.filteredCostCenters = this.listCostCenters;
        return;
      }
      this.constructionSiteStateId = response.constructionSiteStateId;
      this.clientStateId = response.clientStateId;
      setTimeout(() => this.formSuspension.controls["costCenterId"].patchValue(costCenterId));
      this.filteredCostCenters = this.listCostCenters.filter(cc => cc.clientId === response.clientId);
      if (this.formSuspension.get("clientId")?.value !== response.clientId) {
        this.formSuspension.controls["clientId"].patchValue(response.clientId);
      }
    } catch (error) {
      console.error('Error al obtener el centro de costos con Id.', error);
    }
  }

  async getSuspensionById() {
    try {
      const response = await firstValueFrom(this.suspensionService.getSuspensionById(this.suspensionId));
      this.suspensionContract = response;
      const branchChanged = this.branchId != response.branchId;
      if (branchChanged) {
        this.branchId = response.branchId;
        await this.getAllLists(true);
        this.cdr.detectChanges();
      }
      this.consecutive = response.consecutive;
      this.validateForm(this.suspensionContract);
    } catch (error) {
      console.error('Error while getting supension.', error);
    }
  }

  async getPermission(): Promise<void> {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast('warning', `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`, 'Atención');
      }
    } else {
      localStorage.clear();
    }
    await this.getFirstBranchByUserAuthenticatedAsync();
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
      await this.getAllLists(false);
      await this.getPermissionPrint();
    } catch (error) {
      console.error('Error while getting the profile permissions.', error);
    }
  }

  async getPermissionPrint() {
    try {
      this.permissionPrint = await firstValueFrom(this.suspensionService.getPermissionPrint());
      if (this.suspensionId != 0) {
        await this.getSuspensionById();
      }
    } catch (error) {
      console.error('Error to get permission print.', error);
    }
  }

  async getFirstBranchByUserAuthenticatedAsync(): Promise<void> {
    try {
      this.mainBranchByUser = await firstValueFrom(this.userAuthenticatedService.branchObservable
        .pipe(filter(branch => branch && branch.branchId !== 0)));
      this.branchId = this.mainBranchByUser.branchId;
      this.companyId = this.mainBranchByUser.companyId;
    } catch (error) {
      console.error('Error while getting the main branch of the authenticated user.', error);
    }
  }

  async getInvoicingCutoffCode(invoicingCutoffId: number | null) {
    try {
      if (invoicingCutoffId != null && invoicingCutoffId !== 0) {
        this.invoicingCutoffCode = await firstValueFrom(this.invoiceService.getInvoicingCutoffCodeByIdAsync(invoicingCutoffId));
      } else {
        this.invoicingCutoffCode = '';
      }
    } catch (error) {
      this.invoicingCutoffCode = '';
      console.error(`Error while getting the invoicing cutoff code.`, error);
    }
  }

  async getMaintenanceOrderConsecutive(maintenanceOrderId: number | null) {
    try {
      if (maintenanceOrderId != null && maintenanceOrderId !== 0) {
        const maintenanceOrder = await firstValueFrom(this.maintenanceOrderService.getMaintenanceOrderById(maintenanceOrderId));
        this.maintenanceOrderConsecutive = maintenanceOrder.consecutive;
      } else {
        this.maintenanceOrderConsecutive = '';
      }
    } catch (error) {
      this.maintenanceOrderConsecutive = '';
      console.error(`Error while getting the maintenance order consecutive.`, error);
    }
  }

  async getRentalPeriod(rentalPeriodId: number | null) {
    try {
      if (rentalPeriodId != null && rentalPeriodId !== 0) {
        const response = await firstValueFrom(this.suspensionService.getRentalPeriodForRegisterSuspension(rentalPeriodId));
        this.statePeriod = response.statePeriod;
        const statePeriod = this.statePeriod ? 'Abierto' : 'Cerrado';
        const DataPeriod = response.dataPeriod;
        this.dataPeriod = `${DataPeriod} - ${statePeriod}`;
      } else {
        this.dataPeriod = '';
      }
    } catch (error) {
      this.dataPeriod = '';
      console.error(`Error while getting the invoicing cutoff code.`, error);
    }
  }

  goToBack(event: Event) {
    event.preventDefault();
    this.router.navigate([`/${this.url}`]);
  }

  goToHome(event: Event) {
    event.preventDefault();
    this.router.navigate(['/main']);
  }

  get hasMaintenanceOrder(): boolean {
    return this.suspensionContract.maintenanceOrderId != null && this.suspensionContract.maintenanceOrderId != 0;
  }

  private notifyMaintenanceOrderLock(): void {
    this.toastHandlerService.showToast(
      'error',
      'No es posible modificar la suspensión porque tiene una orden de mantenimiento asociada.'
    );
  }

  private isBlockedByMaintenanceOrder(): boolean {
    if (!this.hasMaintenanceOrder) return false;
    this.notifyMaintenanceOrderLock();
    return true;
  }

  private rejectMaintenanceOrderChange(controlName: string, previousValue: unknown): void {
    this.notifyMaintenanceOrderLock();
    setTimeout(() => this.formSuspension.controls[controlName].patchValue(previousValue));
  }

  onChangeDateSuspension(): void {
    if (!this.hasMaintenanceOrder) return;
    this.rejectMaintenanceOrderChange(
      'dateSuspension',
      this.suspensionContract.dateSuspension
        ? this.dateConverterService.convertUtcToLocalDate(this.suspensionContract.dateSuspension)
        : null
    );
  }

  onChangeDays(): void {
    if (!this.hasMaintenanceOrder) return;
    this.rejectMaintenanceOrderChange('days', this.suspensionContract.days);
  }

  onChangeObservation(): void {
    if (!this.hasMaintenanceOrder) return;
    this.rejectMaintenanceOrderChange('observation', this.suspensionContract.observation);
  }

  async handleInitialState() {
    if (this.suspensionId !== null && this.suspensionId !== 0) {
      this.getSuspensionById();
    } else {
      this.createNewRegister();
    }
  }

  private async handleSuspensionNavigation(buttonClick: any, branchId: number, consecutive: number) {
    const actionMap: Record<string, () => Promise<SuspensionModel>> = {
      first: () => firstValueFrom(this.suspensionService.getFirstSuspensionByKeysAsync(branchId)),
      previus: () => firstValueFrom(this.suspensionService.getPreviusSuspensionByKeysAsync(branchId, consecutive)),
      next: () => firstValueFrom(this.suspensionService.getNextSuspensionByKeysAsync(branchId, consecutive)),
      last: () => firstValueFrom(this.suspensionService.getLastSuspensionByKeysAsync(branchId)),
    };
    const action = actionMap[buttonClick.target.id];
    if (!action) {
      this.resetVariables();
      this.suspensionContract = new SuspensionModel();
      this.suspensionContract.branchId = branchId;
      this.validateForm(this.suspensionContract);
      return;
    }
    try {
      const suspension = await action();
      this.suspensionContract = suspension;
      this.suspensionId = suspension.suspensionId;
      this.validateForm(this.suspensionContract);
      this.location.replaceState(`/${this.url}/register/${this.suspensionId}`);
    } catch (error) {
      this.resetVariables();
      this.suspensionContract = new SuspensionModel();
      this.suspensionContract.branchId = branchId;
      this.validateForm(this.suspensionContract);
      this.location.replaceState(`/${this.url}/register`);
      console.error(`Error while getting the suspension (${buttonClick.target.id}).`, error);
    }
  }

  async printPage() {
    if (this.suspensionContract.suspensionId != 0 && this.suspensionContract.suspensionId != null) {
      if (this.permissionPrint) {
        try {
          this.toastHandlerService.clearAllToasts();
          this.suspensionPrintModel = await firstValueFrom(this.suspensionService.getSuspensionByKeysByPrintAsync(this.suspensionContract.branchId, 0,
            this.suspensionContract.suspensionId));
          this.reloadPrint = !this.reloadPrint;

          await this.updateStatePrintSuspension();
        } catch (error) {
          console.error('Error to print suspension.', error);
        }
      } else {
        this.toastHandlerService.showToast('error', 'El usuario no tiene permisos para imprimir suspensiones. Comuníquese con el administrador del sistema.',
          'Error');
      }
    } else {
      this.toastHandlerService.showToast('warning', 'Debe crear un suspensión.', 'Atención');
    }
  }

  reloadWindow(event: Event) {
    event.preventDefault();
    if (this.suspensionId != 0 && this.suspensionId != null) {
      this.router.navigate([`/${this.url}/register/${this.suspensionId}`]);
    } else {
      this.router.navigate([`/${this.url}/register`]);
    }
  }

  resetVariables() {
    this.suspensionId = 0;
    this.consecutive = 0;
    this.quantityDetails = 0;
    this.clientStateId = ClientStateEnums.activo;
    this.constructionSiteStateId = ConstructionSiteStateEnums.activa;
    this.dataPeriod = '';
    this.invoicingCutoffCode = '';
    this.maintenanceOrderConsecutive = '';
  }

  async send() {
    Object.keys(this.formSuspension.controls).forEach(key => {
      const control = this.formSuspension.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value:', control.value);
      }
    });
    if (this.formSuspension.valid) {
      this.formSuspension.controls['consecutive'].enable();
      const modelSuspension = this.formSuspension.value as SuspensionModel;
      //Hago null, los campos que permiten ser nulos:
      if (modelSuspension.observation == "") modelSuspension.observation = null;
      if (this.suspensionId == 0) {
        try {
          const response = await firstValueFrom(this.suspensionService.createSuspension(modelSuspension));
          this.suspensionId = response.suspensionId;
          this.suspensionContract = response;
          this.validateForm(this.suspensionContract);
          this.location.replaceState(`/${this.url}/register/${this.suspensionId}`);
          this.toastHandlerService.showToast('success', 'La suspension fue creada exitosamente.', '');
        } catch (error) {
          console.error('Error while creating the suspension.', error);
        }
      } else {
        this.suspensionContract.costCenterId = modelSuspension.costCenterId;
        this.suspensionContract.dateSuspension = modelSuspension.dateSuspension;
        this.suspensionContract.days = modelSuspension.days;
        this.suspensionContract.observation = modelSuspension.observation;
        try {
          const response = await firstValueFrom(this.suspensionService.updateSuspension(this.suspensionContract));
          this.suspensionContract = response;
          this.validateForm(this.suspensionContract);
          this.toastHandlerService.showToast('success', 'La suspension fue modificada exitosamente.', '');
        } catch (error) {
          console.error('Error while updating the suspension.', error);
        }
      }
    } else {
      this.showValidationMessages()
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      branchId: {
        required: 'El campo Sucursal es obligatorio.'
      },
      dateSuspension: {
        required: 'El campo Fecha es obligatorio.'
      },
      costCenterId: {
        required: 'El campo C.Costos es obligatorio.',
        min: 'Debes seleccionar un C.Costos válido.'
      },
      observation: {
        maxlength: 'El campo Observación no puede tener más de 250 caracteres.'
      }
    };

    Object.keys(controlMessages).forEach(control => {
      const formControl = this.formSuspension.get(control);
      if (formControl && formControl.invalid && formControl.errors) {
        const messages = controlMessages[control];
        Object.keys(formControl.errors).forEach(errorKey => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message, 'Atención');
          }
        });
      }
    });
  }

  async updateFormState() {
    const stateConfig: any = {
      [SuspensionStateEnums.open]: {
        severity: 'danger',
        icon: 'pi pi-lock-open',
        title: 'Cerrar',
        text: 'Abierta',
        isDisabled: false
      },
      [SuspensionStateEnums.closed]: {
        severity: 'success',
        icon: 'pi pi-lock',
        title: 'Abrir',
        text: 'Cerrada',
        isDisabled: true
      },
      [SuspensionStateEnums.printed]: {
        severity: 'info',
        icon: 'pi pi-lock',
        title: 'Abrir',
        text: 'Impresa',
        isDisabled: true
      },
      [SuspensionStateEnums.annul]: {
        severity: 'warn',
        icon: 'pi pi-lock',
        title: 'Abrir',
        text: 'Anulada',
        isDisabled: true
      },
    };

    const currentState = this.suspensionContract.suspensionStateId;
    const config = stateConfig[currentState];
    this.suspensionContract.swBlock ? !config.isDisabled : config.isDisabled;
    if (config) {
      this.iconStateSuspension = config.icon;
      this.titleStateSuspension = config.title;
      this.suspensionStateString = config.text;
      this.disabledForm = config.isDisabled;
      this.disabledActions = config.isDisabled;
      this.disabledDetail = config.isDisabled;
      this.severityState = config.severity;
    }
    if (this.suspensionContract.suspensionStateId == SuspensionStateEnums.open && !this.suspensionContract.swBlock) {
      if (this.suspensionId != 0) {
        setTimeout(() => this.formSuspension.controls["consecutive"].enable(), 100);
      } else {
        setTimeout(() => this.formControlStateService.setControlState(this.formSuspension, ['swBlock', 'consecutive'], false), 100);
      }
    } else {
      setTimeout(() => this.formSuspension.disable(), 100);
      setTimeout(() => this.formControlStateService.setControlState(this.formSuspension, ['branchId', 'consecutive', 'swBlock'], true), 100);
      this.disabledDetail = true;
      this.disabledForm = true;
      this.disabledActions = true;
    }
    if (this.hasMaintenanceOrder) {
      this.disabledDetail = true;
      this.disabledActions = true;
      this.disabledForm = true;
    }
    if (!this.permissionUpdatable) {
      setTimeout(() => this.formSuspension.disable(), 100);
    }
  }

  async updateStatePrintSuspension() {
    try {
      this.suspensionContract = await firstValueFrom(this.suspensionService.printSuspensionAsync(this.suspensionContract.suspensionId));
      await this.validateForm(this.suspensionContract);
    } catch (error) {
      console.error('Error al actualizar el estado a impresa', error)
    }
  }

  async validateForm(suspension: SuspensionModel) {
    this.formSuspension = this.formBuilder.group({
      branchId: [suspension.branchId, [Validators.required, Validators.min(1)]],
      consecutive: [suspension.consecutive],
      dateSuspension: [suspension.dateSuspension ? this.dateConverterService.convertUtcToLocalDate(suspension.dateSuspension)
        : null, [Validators.required]],
      days: [suspension.days],
      costCenterId: [suspension.costCenterId, [Validators.required, Validators.min(1)]],
      swBlock: [suspension.swBlock],
      observation: [suspension.observation, [Validators.maxLength(250)]],
      clientId: [0]
    });
    await this.getCostCenter(suspension.costCenterId, true);
    if (suspension.suspensionId != 0) {
      await Promise.all([
        this.getInvoicingCutoffCode(suspension.invoicingCutoffId),
        this.getRentalPeriod(suspension.rentalPeriodId),
        this.getMaintenanceOrderConsecutive(suspension.maintenanceOrderId)
      ]);
    }
    this.updateFormState();
  }
}